import React, { useContext, useState } from "react";

import { APIContext } from "../../API";

import { Status, StatusButton } from "../misc";
import ThumbnailForm from "./ThumbnailForm";

export default function EditThumbnail(props) {
  const API = useContext(APIContext);

  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const [progress, setProgress] = useState(null);

  const [changed, setChanged] = useState(false);

  function imageSelectHandler(e) {
    setError(null);

    if (e.target.files[0]) {
      if (e.target.files[0].type.substring(0, 5) !== "image") {
        return setError("Invalid thumbnail file type.");
      }

      props.setThumbnail(e.target.files[0]);
      setChanged(true);
    }
  }

  function submit() {
    setError(null);

    if (!props.thumbnail) {
      return setError("Missing Thumbnail");
    }

    setStatus("Uploading");
    API.changeThumbnail(
      props.product,
      props.thumbnail,
      setProgress,
      (err, response) => {
        setStatus(null);
        setProgress(null);
        if (err) {
          return setError(err.response?.data || "Something went wrong");
        }
        props.close && props.close();
      }
    );
  }

  return (
    <>
      <h2 className="mb-1">Edit Thumbnail</h2>
      <ThumbnailForm
        thumbnail={
          typeof props.thumbnail === "string"
            ? props.thumbnail
            : URL.createObjectURL(props.thumbnail)
        }
        onChange={imageSelectHandler}
      />
      <Status error={error} progress={progress} />
      <StatusButton
        text="Submit"
        status={status}
        className="button"
        onClick={submit}
        disabled={!changed}
      />
    </>
  );
}
